module.exports = __webpack_public_path__ + "static/media/020.73e85c2f.jpg";